import { render, staticRenderFns } from "./s06-field.vue?vue&type=template&id=97461e2a&scoped=true"
import script from "./s06-field.vue?vue&type=script&lang=js"
export * from "./s06-field.vue?vue&type=script&lang=js"
import style0 from "./s06-field.vue?vue&type=style&index=0&id=97461e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97461e2a",
  null
  
)

export default component.exports